const items = [
  {
    icon: 'ri-home-4-line',
    label: 'Residential & Commercial',
    sub: 'Full-spectrum painting projects',
  },
  {
    icon: 'ri-user-star-line',
    label: 'Clean, Professional Crews',
    sub: 'Trained & detail-focused',
  },
  {
    icon: 'ri-medal-line',
    label: 'High-End Finish Standards',
    sub: 'Premium materials only',
  },
  {
    icon: 'ri-map-pin-2-line',
    label: 'Illinois Service Coverage',
    sub: 'Elk Grove Village & suburbs',
  },
];

export default function TrustBar() {
  return (
    <section className="bg-charcoal-950 border-b border-gold/10">
      <div className="max-w-[1400px] mx-auto px-6 py-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-0">
          {items.map((item, i) => (
            <div
              key={item.label}
              className={`flex flex-col items-center text-center px-6 py-4 ${
                i < items.length - 1 ? 'border-r border-gold/20' : ''
              }`}
            >
              <div className="w-8 h-8 flex items-center justify-center mb-3">
                <i className={`${item.icon} text-gold`} style={{ fontSize: '24px' }} />
              </div>
              <span className="font-sans text-warm-white text-sm font-medium mb-1">{item.label}</span>
              <span className="font-sans text-warm-dim text-xs">{item.sub}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
